import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Operation } from '../../../models/operation.model';
import { PermissionHelper } from '../../../helpers/permission.helper';
import { MessageService } from '../../../services/message.service';
import { ProductionPlanService } from '../../../services/production-plan.service';

@Component({
  standalone: false,
  selector: 'app-operation-details-modal',
  templateUrl: './operation-details-modal.component.html',
  styleUrls: ['../modal.component.scss'],
})
export class OperationDetailsModalComponent {
  @Input() orderId: string;
  @Input() operation: Operation;
  timeCorrectionEmployee: number;
  timeCorrectionMachine: number;
  quantityCorrection: number;

  @Output() readonly responseChanged = new EventEmitter();

  constructor(private productionPlanService: ProductionPlanService,
              private message: MessageService,
              public permissionHelper: PermissionHelper,
  ) {}

  correctTimeAndQuantity(): void {
    this.productionPlanService
      .operationTimeCorrection(this.orderId, this.operation.id, this.timeCorrectionEmployee, this.timeCorrectionMachine, this.quantityCorrection)
      .subscribe(
        () => {
          this.operation.timeCorrectionEmployee = this.operation.timeCorrectionEmployee + (this.timeCorrectionEmployee || 0);
          this.operation.timeCorrectionMachine = this.operation.timeCorrectionMachine + (this.timeCorrectionMachine || 0);
          this.operation.quantityCorrection = this.operation.quantityCorrection + (this.quantityCorrection || 0);

          this.timeCorrectionEmployee = null;
          this.timeCorrectionMachine = null;
          this.quantityCorrection = null;
          this.message.success('Uspešno ste napravili korekciju vremena i količine');
        },
        err => {
          this.message.error(err);
        }
      );
  }

  emitFalse(): void {
    this.responseChanged.emit(false);
  }
}
